import type { FC } from 'react';

import { IWhoami } from '@mopla/data-models';

import { MainWithFooterTemplate } from '../../molecules/MainWithFooterTemplate';
import {
	IPersonalDetailsPropsV2,
	PersonalDetailsFormV2,
} from '../PersonalDetailsFormV2';

import { EditUserWrapper } from './ProfileManager.styles';

type personalDetails = {
	firstName: string;
	lastName: string;
	phone: string;
	dateOfBirth: string | null;
	streetNumber: string | null;
	zipcode: string | null;
	city: string | null;
};

export interface EditUserScreenProps {
	onEdit: (data: personalDetails) => Promise<any>;
	onUserEdited: () => void;
	currentUser?: IWhoami;
	onAbort: (isDirty: boolean) => void;
}

const renderFn: IPersonalDetailsPropsV2['render'] = ({ content, footer }) => {
	return (
		<MainWithFooterTemplate
			content={<EditUserWrapper>{content}</EditUserWrapper>}
			footer={footer}
		/>
	);
};

export const EditUserScreen: FC<EditUserScreenProps> = ({
	onEdit,
	onUserEdited,
	currentUser,
	onAbort,
}) => {
	return (
		<PersonalDetailsFormV2
			onEdit={onEdit}
			onUserEdited={onUserEdited}
			isUserProfile={true}
			currentUser={currentUser}
			onAbort={onAbort}
			render={renderFn}
		/>
	);
};
